import * as types from './action-types';

export const toggleNavInverse = () => ({ type: types.TOGGLE_NAV_INVERSE });



// WEBPACK FOOTER //
// ./src/store/actions.js